import { createContext } from 'react'

export type LocalisationContextValue = {
  dateLocale: string
  displayLanguage: string
  numberLocale: string
}

export const LocalisationContext = createContext<LocalisationContextValue>(null!)
